import { render, staticRenderFns } from "./FormDetails.vue?vue&type=template&id=1007eacc&scoped=true"
import script from "./FormDetails.vue?vue&type=script&lang=js"
export * from "./FormDetails.vue?vue&type=script&lang=js"
import style0 from "./FormDetails.vue?vue&type=style&index=0&id=1007eacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007eacc",
  null
  
)

export default component.exports